'use strict';

var $ = require('jquery');

function destroy($table) {
	if ($table.data('table')) {
		$table.data('table').destroy();
	}
}

module.exports = {
	init: function () {
		$(document).trigger('enhance.tablesaw');
	},

	destroy: function($table) {
		if ($table) {
			destroy($table);
		}
		else {
			// destroy all tablesaw tables
			$('.tablesaw').each(function() {
				destroy($(this));
			});
		}
	}
};